import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IContactType } from "../../utils/types/models";

export default createEntityReducer<IContactType>(Endpoint.ContactTypes, Endpoint.ContactTypesList);
